var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("floating-" + _vm.meterChange + "-change-indicator")},on:{"after-enter":function($event){return _vm.$emit('complete')}}},[(_vm.animating)?_c('div',{staticClass:"floating-change-indicator"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68a2f943","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/base/FloatingChangeIndicator.vue
// module id = null
// module chunks = 